<template>
  <div class="about-page">
    <recycle-header
      @help="showQrcodeDialog"
    />
    <div class="body">
      <div class="h1 bold">关于我们 | 深圳回收宝科技有限公司（简称：回收宝）</div>

      <div class="h2 bold">回收宝简介</div>

      <div class="h3">回收宝是由阿里巴巴战略投资的，以二手手机数码产品交易为核心的“互联网+循环经济”企业。</div>

      <div class="h3">回收宝秉承”让闲置回归价值“为使命，致力于成为全球最专业的手机数码回收平台；通过“验机宝”、“天工验机”、“全自动回收ATM”等科技创新，提升二手手机交易的线上化、标准化、数字化，不断管理和延长电子设备生命周期，为可持续发展提供新思路。</div>

      <div class="h3">回收宝目前已与天猫、闲鱼、支付宝、华为、vivo、OPPO、小米、荣耀等品牌达成战略合作伙伴关系，减少废弃电子产品对环境带来的影响，携手建设可持续的生活方式。</div>

      <div class="h2 bold">发展历程</div>

      <div class="h3">2014年7月，回收宝成立</div>

      <div class="h3">2014年10月，与广东移动建立深度业务合作</div>

      <div class="h3">2015年8月，与华为官网建立深度业务合作</div>

      <div class="h3">2015年8月，获源码资本数百万美元天使轮投资</div>

      <div class="h3">2016年6月，获成为资本、中信资本近亿元A轮投资</div>

      <div class="h3">2016年6月，与苹果-爱锋派建立深度业务合作</div>

      <div class="h3">2016年7月，与中国联通建立全国深度业务合作</div>

      <div class="h3">2016年9月，与中国移动建立全国深度业务合作</div>

      <div class="h3">2016年11月，获SMC(世铭资本)A+轮投资</div>

      <div class="h3">2016年12月，与微信建立深度业务合作</div>

      <div class="h3">2017年5月，对“闪修侠”进行A轮战略投资</div>

      <div class="h3">2017年9月，与vivo官网建立深度业务合作</div>

      <div class="h3">2017年9月，与蚂蚁金服旗下芝麻信用建立深度业务合作</div>

      <div class="h3">2017年9月，获海峡资本三亿元B轮投资</div>

      <div class="h3">2017年10月，与阿里巴巴旗下闲鱼建立深度业务合作</div>

      <div class="h3">2018年1月，回收宝正式启动全球化战略，全方位布局海外业务</div>

      <div class="h3">2018年3月，回收宝发布自主研发的手机回收机器人</div>

      <div class="h3">2018年3月，回收宝发布二手优品品牌“可乐优品”</div>

      <div class="h3">2018年4月，与OPPO官网建立深度业务合作</div>

      <div class="h3">2018年5月，作为官方合作伙伴携手天猫推出手机以旧换新</div>

      <div class="h3">2018年5月，旗下信用租赁品牌“拿趣用”正式升级上线</div>

      <div class="h3">2018年9月，获阿里巴巴集团C1轮战略投资</div>

      <div class="h2 bold">业务矩阵</div>

      <div class="h3">● 回收宝：回收宝以“用户第一”为核心价值观，目前已布局邮寄回收(包含信用回收)、到家回收、到店回收(包含手机回收机器人回收)等线上线下融合式的回收场景，全力为用户提供更好的服务体验。</div>

      <div class="h3">● 拿趣用：回收宝旗下信用租赁品牌，为年轻消费群体提供更具价值的租赁服务，让有信用的人即刻享受品质生活。</div>

      <div class="h3">● 可乐优品：回收宝旗下二手优品品牌，原装好货、心动价格。</div>

      <div class="h3">● 换机侠：换机侠是回收宝线下业务品牌，致力于线上线下融合，为用户提供回收、保险、租机、维修、优品等手机后市场全产业链服务，与线下合作商共建新零售业态。</div>

      <div class="h3">● 闪修侠：国内最大的手机上门维修O2O平台。拥有覆盖北京、上海、广州等23个城市的直营服务网络，提供手机、平板、笔记本、无人机等维修服务。2017年，回收宝战略投资闪修侠，完成手机后市场闭环布局。</div>

      <div class="h2 bold">企业使命</div>

      <div class="h3">让闲置回归价值</div>

      <div class="h2 bold">公益事业</div>

      <div class="h3">● 2015年7月，回收宝响应“益起跑”公益宣言，携手深圳本土多家O2O企业联合发起“趁年轻，为爱跑”接力跑步公益活动。</div>

      <div class="h3">● 2017年5月，回收宝参与阿拉善SEE公益机构发起的"一亿棵梭梭树"计划，防治荒漠化蔓延，改善区域环境。</div>

      <div class="h2 bold">公司荣誉</div>

      <div class="h3">● 创业邦100 - 中国创新成长企业100强</div>

      <div class="h3">● 2017WISE大会 - 年度最佳B轮公司</div>

      <div class="h3">● 2017创业黑马TOP100 - 中国最具潜力创业公司</div>

      <div class="h3">● 2017投中 - 年度中国互联网产业“最佳互联网领域投资案例”TOP10</div>

      <div class="h3">● 2018胡润 - 中国最具投资价值新星企业百强榜</div>
    </div>
    <recycle-footer />
  </div>
</template>

<script>
import RecycleHeader from '@@/views/welcome/components/recycle-header';
import RecycleFooter from '@@/views/welcome/components/recycle-footer';

export default {
  components: {
    RecycleHeader,
    RecycleFooter
  },
  methods: {
    showQrcodeDialog (item) {
      this.selectClient = item;
      this.qrcodeVisible = true;
    }
  }
};
</script>

<style scoped>
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/about/index.vue